import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Header } from "@/components/portfolio/Header";
import { Hero } from "@/components/portfolio/Hero";
import { MarqueeBand } from "@/components/portfolio/MarqueeBand";
import { About } from "@/components/portfolio/About";
import { CaseStudies } from "@/components/portfolio/CaseStudies";
import { Skills } from "@/components/portfolio/Skills";
import { Experience } from "@/components/portfolio/Experience";
import { Contact } from "@/components/portfolio/Contact";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App" data-testid="app-root">
      <div className="noise-overlay" />
      <Header />
      <main>
        <Hero />
        <MarqueeBand />
        <About />
        <CaseStudies />
        <Skills />
        <Experience />
        <Contact />
      </main>
    </div>
  );
}

export default App;
